module.exports = __webpack_public_path__ + "img/b7af541.jpg";